import React from 'react';

const EditIcon = ({ width = 16, height = 16, fill = "#F04F4F" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0725 10.4987H6.82119C6.54519 10.4987 6.32119 10.7227 6.32119 10.9987C6.32119 11.2747 6.54519 11.4987 6.82119 11.4987H11.0725C11.3485 11.4987 11.5725 11.2747 11.5725 10.9987C11.5725 10.7227 11.3485 10.4987 11.0725 10.4987Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.24461 3.15974C4.3109 3.07156 4.43608 3.05372 4.52437 3.11986L7.97768 5.7068C8.06615 5.77307 8.08408 5.89854 8.01772 5.98694L4.80459 10.2668C4.03125 11.3002 2.86459 11.5068 2.05792 11.5068C1.55792 11.5068 1.19792 11.4268 1.15792 11.4202C1.07125 11.4002 0.991253 11.3402 0.944586 11.2602C0.89792 11.1735 -0.248747 9.1335 1.03125 7.4335L4.24461 3.15974Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.30459 4.27349L8.85791 4.86731C8.7916 4.95546 8.66645 4.97328 8.57817 4.90715L5.1243 2.3198C5.03604 2.25368 5.01795 2.12859 5.08387 2.04018L5.53126 1.44016C5.99126 0.820157 6.70459 0.49349 7.42459 0.49349C7.91792 0.49349 8.41126 0.646824 8.83792 0.966824C9.33792 1.34682 9.66459 1.90016 9.75792 2.52016C9.84459 3.14682 9.68459 3.76682 9.30459 4.27349Z"
      fill={fill}
    />
  </svg>
);

export default EditIcon;